import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { PageInfoService, PageLink } from '@metronic/layout';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from '@services/base-service.service';
import { BehaviorSubject, shareReplay, Subscription } from 'rxjs';
import { UtilitiesService } from '@services/utilities.service';
import { RolePrivilegeService } from '@services/role-privilege.service';
import { TabListLabelRejected } from '../../enum/tablist-label.enum';
import { RegistrationRejectComponent } from './registration-reject/registration-reject.component';
import { VerificationRejectComponent } from './verification-reject/verification-reject.component';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { DistributorTabStatus } from '@config/enum/distributor.enum';
import { API } from '@config/constants/api.constant';

@Component({
  selector: 'app-reject',
  templateUrl: './reject.component.html',
  styleUrls: ['./reject.component.scss'],
})
export class RejectComponent implements OnInit, AfterViewInit, OnDestroy {
  links: Array<PageLink> = [
    {
      title: 'Distributor',
      path: '',
      isActive: false,
    },
    {
      title: '',
      path: '',
      isActive: false,
      isSeparator: true,
    },
    {
      title: 'Ditolak',
      path: '',
      isActive: true,
    },
  ];

  countRegister = new BehaviorSubject(0);
  countVerification = new BehaviorSubject(0);

  tabIndex: number = 0;
  tab: any | null = null;

  TabListLabel = TabListLabelRejected;
  tabList: any[] = [];

  private unsubscribe: Subscription[] = [];

  constructor(
    private pageInfoService: PageInfoService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private baseService: BaseService,
    public utilities: UtilitiesService,
    private rolePrivilegeService: RolePrivilegeService
  ) {}

  ngOnInit(): void {
    this.initTabList();
    this.handlePrivilege();
    this.initPageInfo();
  }

  ngAfterViewInit() {
    this.initGetListDataCount();
  }

  initTabList() {
    this.tabList = [
      {
        tab: 'registration',
        enumChild: 'TAB_LIST_REGISTRATION_REJECT',
        labelKey: 'registration_reject',
        privilege: null,
        dataCount: this.countRegister,
        component: RegistrationRejectComponent,
      },
      {
        tab: 'verification',
        enumChild: 'TAB_LIST_VERIFICATION_REJECT',
        labelKey: 'verification_reject',
        privilege: null,
        dataCount: this.countVerification,
        component: VerificationRejectComponent,
      },
    ];

    this.tab = this.activatedRoute.snapshot.params.tab;
    const _currentActiveTab = this.tabList.filter((item) => item.tab === this.tab);
    this.tabIndex = this.tabList.indexOf(_currentActiveTab[0]);
  }

  handlePrivilege() {
    this.tabList.map((tab) => {
      tab.privilege = this.rolePrivilegeService.checkPrivilege('DISTRIBUTOR', 'LIST_DITOLAK', tab.enumChild);
    });

    this.changeFirstTab();
  }

  changeFirstTab() {
    const _data: { tab: string; privilege: boolean }[] = [];
    this.tabList.forEach((item) => {
      _data.push({ tab: item.tab, privilege: !!item.privilege });
    });

    if (!this.tabList[0].privilege) {
      const _changeTab = this.rolePrivilegeService.changePrivilegeUrlTab(_data, 'distributor', DistributorTabStatus.REJECT);
      this.router.navigate([_changeTab]).then();
    }
  }

  tabClick(e: MatTabChangeEvent) {
    this.tabIndex = e.index;

    const _tabLabel = e.tab.textLabel;
    const _indexOfTab = Object.values(TabListLabelRejected).indexOf(_tabLabel as TabListLabelRejected);

    const { tab } = this.tabList[_indexOfTab];

    this.router.navigate([`/distributor/reject/${tab}`]).then(() => this.initPageInfo());
  }

  initPageInfo() {
    this.pageInfoService.updateTitle('Distributor Ditolak');
    this.pageInfoService.updateBreadcrumbs(this.links);
  }

  initGetListDataCount() {
    const _dataCounterSubs = this.baseService
      .getData<any>(API.DISTRIBUTOR.LIST_COUNTER.REJECT)
      .pipe(shareReplay())
      .subscribe((resp) => {
        if (!resp) return;
        const { distributor_registration_rejected, distributor_verification_rejected } = resp && resp.data;
        this.countRegister.next(distributor_registration_rejected ?? 0);
        this.countVerification.next(distributor_verification_rejected ?? 0);
      });

    this.unsubscribe.push(_dataCounterSubs);
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}
